import Vue from "vue";
import App from "./App.vue";
import router from "@/router/index"
import store from "./store";
import ElementUI from 'element-ui';
import "./styles/main.scss"
import "video.js/dist/video-js.min.css"
import "./plugins/element-variables.scss";

Vue.use(ElementUI)
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
